import { constructAuthenticatedRoute } from '~/core/shared/utils/routing';
import { MIDDLE_OFFICE_ADMIN_BASE_URL } from './settings';

export const MIDDLE_OFFICE_APPLICATIONS_BASE_URL = `${MIDDLE_OFFICE_ADMIN_BASE_URL}/applications`;
export const MIDDLE_OFFICE_APPLICATION_BASE_URL = `${MIDDLE_OFFICE_APPLICATIONS_BASE_URL}/:uuid`;

export const MIDDLE_OFFICE_APPLICATION_ROUTES = {
  applications: constructAuthenticatedRoute(
    MIDDLE_OFFICE_APPLICATIONS_BASE_URL,
    'Applications',
  ),
  application: constructAuthenticatedRoute(
    MIDDLE_OFFICE_APPLICATION_BASE_URL,
    'Application',
  ),
} as const;
